import ApiService from '../common/api.service'

class BannerService extends ApiService {

  /**
   * Get banners.
   * @param {object} params - parametres needed to retrieve the banners
   * @return {promise} banners
   */
  getBanners (params) {
    const inCache = this.getFromCache(params)
    if (inCache) {
      // Get result form cache
      return Promise.resolve(inCache)
    }
    return this.get('/catalog/banners', {params})
      .then((res) => {
        this.$log.info('Fetched banners', res.data)
        this.putInCache(params, res.data)
        return Promise.resolve(res.data)
      })
  }
}

export default BannerService



// WEBPACK FOOTER //
// ./src/app/services/banner/banner.service.js